import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { PRODUCT_ICON_MAP } from '../../../product-subpage/productIcons';
import type { ProductSubpageConfig } from '../../../product-subpage/types';

export const PlatformSubFeatures: React.FC<{
  capabilities: ProductSubpageConfig['capabilities'];
}> = ({ capabilities }) => (
  <SiteSection id="capabilities" className="platform-sub-capabilities platform-sub-capabilities--premium">
    <SiteSectionHeader
      eyebrow={capabilities.eyebrow}
      title={capabilities.title}
      subtitle={capabilities.subtitle}
      align="center"
    />
    <ul className="platform-sub-capabilities__grid platform-sub-capabilities__grid--premium">
      {capabilities.items.map((item) => {
        const Icon = PRODUCT_ICON_MAP[item.icon];
        return (
          <li key={item.title} className="platform-sub-capability-card platform-sub-capability-card--premium">
            <div className="platform-sub-capability-card__head">
              <span className="platform-sub-capability-card__icon" aria-hidden>
                <Icon size={22} strokeWidth={1.65} />
              </span>
              <h3 className="platform-sub-capability-card__title">{item.title}</h3>
            </div>
            {item.bullets?.length ? (
              <ul className="platform-sub-capability-card__list">
                {item.bullets.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            ) : item.description ? (
              <p className="platform-sub-capability-card__desc">{item.description}</p>
            ) : null}
          </li>
        );
      })}
    </ul>
  </SiteSection>
);
